import React, { useEffect, useRef, useMemo, useCallback } from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import domToImage from "dom-to-image";

const KOTPrintIMIN = ({ session, items = [], kotNumber, onPrintComplete, onLog, triggerPrint = false }) => {
  const printRef = useRef();
  const hasPrintedRef = useRef(false);

  const portalEl = useMemo(() => {
    if (typeof document === "undefined") return null;
    const el = document.createElement("div");
    el.setAttribute("data-kot-print", "imin");
    el.style.position = "absolute";
    el.style.left = "0";
    el.style.top = "0";
    el.style.width = "0";
    el.style.height = "0";
    el.style.overflow = "hidden";
    return el;
  }, []);

  useEffect(() => {
    if (!portalEl || typeof document === "undefined") return;
    document.body.appendChild(portalEl);
    return () => {
      if (portalEl.parentNode) {
        portalEl.parentNode.removeChild(portalEl);
      }
    };
  }, [portalEl]);

  const handlePrintWithImin = useCallback(() => {
    // Check if IMIN printer is available
    if (window.IminPrinter) {
      var IminPrintInstance = new window.IminPrinter();
      console.log("IminPrinter", IminPrintInstance);

      try {
        // Create a WebSocket connection
        IminPrintInstance.connect().then(async (isConnect) => {
          // The WebSocket status is linked
          if (isConnect) {
            IminPrintInstance.initPrinter();
            const status = await IminPrintInstance.getPrinterStatus();
            console.log("Printer status:", status);

            const node = printRef.current;

            if (node) {
              domToImage.toJpeg(node).then(function (dataUrl) {
                IminPrintInstance.printSingleBitmap(dataUrl);
                setTimeout(function () {
                  // After the delay, feed paper
                  IminPrintInstance.printAndFeedPaper(100);
                  // Cut the paper after feeding
                  IminPrintInstance.partialCut();
                  if (onPrintComplete) onPrintComplete();
                }, 3000);
              });
            }
          }
        });
      } catch (err) {
        alert("Error: IMIN ERROR: " + err.message);
      }
    } else {
      alert("IminPrinter is not available.");
    }
  }, [onPrintComplete]);

// Trigger print when triggerPrint becomes true (like button click)
useEffect(() => {
  if (!items?.length || !triggerPrint) return;

  // ✅ Prevent duplicate printing on re-render / prop changes
  if (hasPrintedRef.current) return;
  hasPrintedRef.current = true;

  handlePrintWithImin();
}, [triggerPrint, items, handlePrintWithImin]);


  if (!items?.length) return null;
  const content = (
    <div style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
      <div
        ref={printRef}
        style={{
          width: "556px",
          padding: "20px 10px",
          lineHeight: "35px",
          backgroundColor: "white",
          border: "0px solid #FFFFFF",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontSize: "30px",
            fontWeight: "bold",
          }}
        >
          Kitchen Order Ticket
        </div>
        <div
          style={{
            textAlign: "center",
            fontSize: "32px",
            fontWeight: "bold",
            marginTop: "6px",
          }}
        >
          KOT #{kotNumber}
        </div>

        <div style={{ fontSize: "24px", marginTop: "10px" }}>
          <div>
            <strong>Table / Order:</strong> {session?.label || "—"}
          </div>
          <div>
            <strong>Time:</strong> {moment().format("hh:mm A")}
          </div>
          <div>
            <strong>Date:</strong> {moment().format("MMM DD, YYYY")}
          </div>
        </div>

        <div
          style={{
            width: "100%",
            borderBottom: "medium dotted #333333",
            height: "5px",
            marginTop: "10px",
          }}
        />

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "24px",
            marginTop: "10px",
          }}
        >
          <thead>
            <tr>
              <th style={{ textAlign: "left", fontSize: "26px" }}>Item</th>
              <th style={{ textAlign: "right", fontSize: "26px" }}>Qty</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => (
              <tr key={idx}>
                <td style={{ textAlign: "left", fontSize: "24px" }}>
                  {item.name}
                  {item.remark && (
                    <div style={{ fontSize: "18px", fontStyle: "italic", color: "#666", marginTop: "4px" }}>
                      Remark: {item.remark}
                    </div>
                  )}
                </td>
                <td style={{ textAlign: "right", fontSize: "24px" }}>{item.qty}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div
          style={{
            width: "100%",
            borderBottom: "medium dotted #333333",
            height: "5px",
            marginTop: "15px",
          }}
        />

        <div
          style={{
            fontSize: "26px",
            fontWeight: "bold",
            textAlign: "center",
            marginTop: "15px",
          }}
        >
          Total Items: {items.length}
        </div>

        <div
          style={{
            fontSize: "24px",
            textAlign: "center",
            marginTop: "16px",
          }}
        >
          Printed at {moment().format("MMM DD, YYYY hh:mm A")}
        </div>
      </div>
    </div>
  );

  if (!portalEl) return content;
  return ReactDOM.createPortal(content, portalEl);
};

export default KOTPrintIMIN;
